import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:py-16">
        <div className="mx-auto max-w-3xl text-center">
          <p className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
            <i className="ri-question-line" />
            关于 51吃料
          </p>
          <h2 className="mt-4 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            关于追更，你可能想问这些
          </h2>
          <p className="mt-3 text-sm leading-6 text-foreground-500">
            把「持续更新、实时跟进、最新进展」背后的门道，用大白话讲清楚。
          </p>
        </div>

        <div className="mx-auto mt-9 max-w-3xl space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3">
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-heading text-sm font-black ${
                      isOpen ? "bg-primary-600 text-background-50" : "bg-accent-100 text-accent-800"
                    }`}>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-[15px] font-bold text-foreground-950">{f.q}</span>
                  </span>
                  <i
                    className={`ri-add-line shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${isOpen ? "rotate-45 text-primary-600" : ""}`}
                  />
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[60px] text-sm leading-7 text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}